import { useState } from 'react';

import { NavLink } from 'react-router-dom';

import classNames from 'classnames';

import { ChevronIcon } from '../../icons';

import classes from './MobileMenu.module.css';

const MobileMenuItem = ({ item, setClosing }) => {

    const { key, name, categories=[] } = item;
    
    const [submenu, setOpenSubMenu] = useState(null);

    const onClick = () => {
        setClosing(true);
    }

    return (
        <div className={classes.item} onClick={() => {
            setOpenSubMenu((submenu === 0 ? null : 0));
        }}>
            <span className={classes.label_container}>
                <span>{ name }</span>
                <span className={classNames(classes.chevron, (submenu === 0 && classes.chevron_open))} >
                    <ChevronIcon size={16} direction='bottom' />
                </span>
            </span>

            <nav className={classNames(classes.submenu, (submenu === 0 && classes.submenu_open))}>
                <NavLink key={key} to={'/' + key} onClick={onClick}>{ name }</NavLink>
                {
                    categories && categories.map((category) => {
                        return category.visible ? <NavLink key={category.key} to={'/' + category.key} onClick={onClick}>{category.name}</NavLink> : null;
                    })
                }
            </nav>
        </div>
    );
}

export default MobileMenuItem;